import { Directive, Optional, Self, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControlDirective, FormControlName } from '@angular/forms';

@Directive({
  selector: '[formControl], [formControlName], formControl, formControlName'
})
export class FormNativeElementDirective implements OnInit, OnDestroy {

  constructor(@Self() @Optional() private formControlDirective: FormControlDirective,
  @Self() @Optional() private formControlName: FormControlName,
  private elementRef: ElementRef) { }

  ngOnInit(): void {
    var formControl =  this.formControlDirective || this.formControlName;
    if(formControl && formControl.control) {
      (formControl.control as any).elementRef = this.elementRef;
    }
  }

  ngOnDestroy(): void {
    var formControl =  this.formControlDirective || this.formControlName;
    if(formControl && formControl.control) {
      (formControl.control as any).elementRef = undefined;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/directives/form-native-element.directive.ts